module.exports = "/admin_success_screen-5b2db604a6e72112fe80439863c6d3e3.svg";